export default "__VITE_ASSET__8WxBYkyW__"